export default __webpack_public_path__ + "static/media/externalForce.45f265a5.png";